import { input, label } from './adminUi';

export default function VarietySpecsFields({ specs, onChange }) {
  const rows = Array.isArray(specs) && specs.length > 0 ? specs : [{ label: '', value: '' }];

  function setRow(index, field, value) {
    const next = rows.map((r, i) => (i === index ? { ...r, [field]: value } : r));
    onChange(next);
  }

  function addRow() {
    onChange([...rows, { label: '', value: '' }]);
  }

  function removeRow(index) {
    const next = rows.filter((_, i) => i !== index);
    onChange(next.length ? next : [{ label: '', value: '' }]);
  }

  return (
    <div className="rounded-xl border border-neutral-200/90 bg-neutral-50/80 p-4 sm:p-5">
      <div className="mb-3 flex flex-wrap items-center justify-between gap-2">
        <p className="text-xs font-semibold uppercase tracking-wide text-neutral-500">Specification rows</p>
        <button
          type="button"
          onClick={addRow}
          className="rounded-lg border border-neutral-300 bg-white px-3 py-1.5 text-xs font-semibold text-neutral-800 hover:bg-neutral-50"
        >
          + Add row
        </button>
      </div>
      <ul className="m-0 list-none space-y-3 p-0">
        {rows.map((row, i) => (
          <li key={i} className="grid gap-3 sm:grid-cols-[1fr_1fr_auto] sm:items-end">
            <label className={label}>
              Label
              <input
                className={input}
                value={row.label}
                onChange={(e) => setRow(i, 'label', e.target.value)}
                placeholder="e.g. Color"
              />
            </label>
            <label className={label}>
              Value
              <input
                className={input}
                value={row.value}
                onChange={(e) => setRow(i, 'value', e.target.value)}
                placeholder="e.g. Attractive Red"
              />
            </label>
            <button
              type="button"
              onClick={() => removeRow(i)}
              className="h-10 shrink-0 rounded-lg border border-red-200 bg-white px-3 text-xs font-semibold text-red-700 hover:bg-red-50 sm:mb-px"
            >
              Remove
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
}
